import { Product, ProductPersonalBibSettings } from "../../../model/Product";

type Props = "productRequiresSocialSecurityNumber" | "preRaceEntryOpen" | "raceEntryOpen" | "raceEntriesCanBeChanged" | "raceStartCertificateAvailable" | "physicalProduct" | "participantCanChangeStartGroup" |
    "requiresSex" | "requiresDateOfBirth" | "requiresNationality" | "requiresAddress" | "requiresCountry" | "personalBib" | "openForTeamTags" | "canBePurchasedAtMyPages" | "canBePurchasedAtB2bPortal";
export type ProductSettings = Pick<Product, Props>;

export const getInitialValue = (source: ProductSettings): ProductSettings => {
    return {
        productRequiresSocialSecurityNumber: !!source?.productRequiresSocialSecurityNumber,
        preRaceEntryOpen: !!source?.preRaceEntryOpen,
        raceEntryOpen: !!source?.raceEntryOpen,
        raceEntriesCanBeChanged: !!source?.raceEntriesCanBeChanged,
        raceStartCertificateAvailable: !!source?.raceStartCertificateAvailable,
        physicalProduct: !!source?.physicalProduct,
        participantCanChangeStartGroup: !!source?.participantCanChangeStartGroup,
        requiresSex: !!source?.requiresSex,
        requiresDateOfBirth: !!source?.requiresDateOfBirth,
        requiresNationality: !!source?.requiresNationality,
        requiresAddress: !!source?.requiresAddress,
        requiresCountry: !!source?.requiresCountry,
        personalBib: !!source?.personalBib,
        openForTeamTags: !!source?.openForTeamTags,
        canBePurchasedAtMyPages: !!source?.canBePurchasedAtMyPages,
        canBePurchasedAtB2bPortal: !!source?.canBePurchasedAtB2bPortal
    };
};

export const getInititalBibSettingsValue = (productId: string, source?: ProductPersonalBibSettings): ProductPersonalBibSettings => {
    return source ?? {
        id: productId,
        bibProductId: null,
        sponsors: [],
        handoutLocations: [],
        template: "vasaloppet",
        canBeBought: false,
        handoutLocationCanBeChanged: false,
        isArchived: false
    };
}
